var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[(_vm.initialized && _vm.ready)?_c('admin-filters',{attrs:{"filters":_vm.filters,"links":_vm.filterLinks}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }